import { render, staticRenderFns } from "./Privacy2.vue?vue&type=template&id=51faedc6&scoped=true"
import script from "./Privacy2.vue?vue&type=script&lang=js"
export * from "./Privacy2.vue?vue&type=script&lang=js"
import style0 from "./Privacy2.vue?vue&type=style&index=0&id=51faedc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51faedc6",
  null
  
)

export default component.exports